import cx from 'classnames';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DatePicker } from '../date-picker';
import styles from './date-picker-range.module.scss';
var DatePickerType;
(function (DatePickerType) {
    DatePickerType[DatePickerType["START_DATE_DATE_PICKER"] = 0] = "START_DATE_DATE_PICKER";
    DatePickerType[DatePickerType["END_DATE_DATE_PICKER"] = 1] = "END_DATE_DATE_PICKER";
})(DatePickerType || (DatePickerType = {}));
export const DatePickerRange = ({ id, className, startDateLabelText, endDateLabelText, startDateUnderLineText, endDateUnderLineText, startDatePlaceholderText, endDatePlaceholderText, onChange, startDate = null, endDate = null, startDateErrorMessage, showStartDateError = false, endDateErrorMessage, showEndDateError = false, isSameDateAllowed = true, ...restProps }) => {
    const containerClassNames = cx(className, styles.rangeContainer);
    const [dpStartDate, setDpStartDate] = useState(startDate);
    const [dpEndDate, setDpEndDate] = useState(endDate);
    const [isStartDateHasError, setIsStartDateHasError] = useState(false);
    const [isEndDateHasError, setIsEndDateHasError] = useState(false);
    useEffect(() => {
        setDpStartDate(startDate);
        setDpEndDate(endDate);
    }, [startDate, endDate, endDateUnderLineText]);
    const handleStartDateChange = (date, event) => {
        setDpStartDate(date);
        if (onChange) {
            onChange(date, dpEndDate, event);
        }
        if (moment(dpEndDate) < moment(date) ||
            (!isSameDateAllowed && moment(dpEndDate).isSame(date))) {
            setIsStartDateHasError(true);
        }
        else {
            setIsStartDateHasError(false);
            setIsEndDateHasError(false);
        }
    };
    const handleEndDateChange = (date, event) => {
        setDpEndDate(date);
        if (onChange) {
            onChange(dpStartDate, date, event);
        }
        if (moment(date) < moment(dpStartDate) ||
            (!isSameDateAllowed && moment(date).isSame(dpStartDate))) {
            setIsEndDateHasError(true);
        }
        else {
            setIsStartDateHasError(false);
            setIsEndDateHasError(false);
        }
    };
    const handleDateChange = (datePickerType, date, event) => {
        switch (datePickerType) {
            case DatePickerType.START_DATE_DATE_PICKER:
                handleStartDateChange(date, event);
                break;
            case DatePickerType.END_DATE_DATE_PICKER:
                handleEndDateChange(date, event);
                break;
            default:
                // do nothing
                break;
        }
    };
    return (React.createElement("div", { className: containerClassNames },
        React.createElement(DatePicker, { label: startDateLabelText, underLineText: (isStartDateHasError || showStartDateError) &&
                startDateErrorMessage
                ? startDateErrorMessage
                : startDateUnderLineText, onChange: (date, event) => handleDateChange(DatePickerType.START_DATE_DATE_PICKER, date, event), selected: dpStartDate, className: cx(styles.datepicker, styles.startDatePicker), placeholderText: startDatePlaceholderText, hasError: isStartDateHasError || showStartDateError, ...restProps }),
        React.createElement(DatePicker, { label: endDateLabelText, underLineText: (isEndDateHasError || showEndDateError) &&
                endDateErrorMessage
                ? endDateErrorMessage
                : endDateUnderLineText, onChange: (date, event) => handleDateChange(DatePickerType.END_DATE_DATE_PICKER, date, event), selected: dpEndDate, className: cx(styles.datepicker, styles.endDatePicker), placeholderText: endDatePlaceholderText, hasError: isEndDateHasError || showEndDateError, ...restProps })));
};
//# sourceMappingURL=date-picker-range.js.map